import { InjectionToken } from '@angular/core'


export const dynamicRenderControlToken = new InjectionToken('DYNAMIC_RENDER_CONTROL')
export const dynamicRenderPropsToken = new InjectionToken('DYNAMIC_RENDER_PROPS')
